import React from "react";
import { TextField, IconButton, Grid, InputAdornment } from "@mui/material";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import EmailIcon from "@mui/icons-material/Email";
import LockIcon from "@mui/icons-material/Lock";
const Input = ({
  half,
  handleChange,
  label,
  name,
  type,
  handleShowPassword,
  autoFocus,
}) => (
  <Grid item xs={12} sm={half ? 6 : 12}>
    <TextField
      name={name}
      onChange={handleChange}
      variant='outlined'
      autoFocus={autoFocus}
      size='small'
      required
      fullWidth
      placeholder={label}
      style={{ width: "250px" }}
      label={label}
      type={type}
      autoComplete={name === "password" ? "off" : ""}
      InputProps={
        name === "password"
          ? {
              endAdornment: (
                <InputAdornment position='end'>
                  <IconButton onClick={handleShowPassword}>
                    {type === "password" ? (
                      <VisibilityIcon style={{ color: "#3e5059" }} />
                    ) : (
                      <VisibilityOffIcon style={{ color: "#3e5059" }} />
                    )}
                  </IconButton>
                </InputAdornment>
              ),
              startAdornment: (
                <InputAdornment position='start'>
                  <LockIcon style={{ color: "#3e5059" }} />
                </InputAdornment>
              ),
              disableUnderline: true,
            }
          : {
              startAdornment: (
                <InputAdornment position='start'>
                  <EmailIcon style={{ color: "#3e5059" }} />
                </InputAdornment>
              ),
              disableUnderline: true,
            }
      }
    />
  </Grid>
);

export default Input;
